<template>
  <div class="container">
    <app-header :title="title" />
    <van-search v-model="value"
               @click="$router.push('/search')"
                placeholder="搜索商品名称" />
    <div class="recommend-content">
      <Goods :productList="productList"/>
    </div>
  </div>
</template>

<script>
import Goods from './Goods'
import { getProductCpModuleGood } from '@/api/product/index.js'
export default {
  name: 'Index',
  components: {
    Goods
  },
  data () {
    return {
      value: '',
      productList: [],
      title: '',
      // 是否收藏
      iscollect: false,
      collect: require('@/assets/collect.png'),
      collect01: require('@/assets/collect01.png')
    }
  },
  created () {
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == 'home') {
        vm.title = vm.$route.query.name
        vm._getProductCpModuleGood()
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    to.meta.keepAlive = true // 给列表(list.vue)页面设置keepAlive
    localStorage.setItem("scrollToplist", document.documentElement.scrollTop)
    next()
  },
  activated:function() {
    this.$nextTick(() => {
      document.documentElement.scrollTop = localStorage.getItem("scrollToplist")
      localStorage.setItem("scrollToplist", 0)
    })
  },
  methods: {
    gotoSearchProduct () {
      if (this.value == '') {
        return
      }
      this.$router.push({
        path: '/searchProduct',
        query: {
          name: this.value
        }
      })
    },
    _getProductCpModuleGood () {
      const params = {
        gid: this.$route.query.id,
        gidAd : this.$route.query.ad
      }
      getProductCpModuleGood(params).then((res) => {
        if (res.success) {
          for (var i = 0; i < res.data.length; i++) {
            res.data[i]['image'] = res.data[i].img
          }
          this.productList = res.data
        }
      })
    },
    onNavigate (item) {
      this.$router.push({
        path: 'product/detail',
        query: { id: item.pid }
      })
    },
    // 点击收藏图片,收藏商品
    collectionGoods (index) {
      console.log(index);
    },
    // 点击加入购物车,添加商品到购物车
    addToCart () { console.log(456); }
  }
}
</script>

<style lang="less" scoped>
.container {

  .recommend-content {
    background: #ffffff;
    .item {
      border: 1px solid rgba(243, 243, 243, 1);
      .name {
        height: 38px;
        font-size: 14px;
        font-weight: bold;
        line-height: 17px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
      }
      .footer {
        display: flex;
        justify-content: space-between;
        .price {
          height: 30px;
          font-size: 16px;
          font-weight: bold;
          line-height: 30px;
          color: rgba(254, 0, 59, 1);
        }
        .box {
          img {
            width: 25px;
            height: 25px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/modules/product_list.vue